const bean = {
  bean: 'Bean',
  tips: '*Değişim için minimum bean: {{ num }}',
  dailyExchangeTimes: 'Günlük değişim sayısı:',
  dailyExchangeQuota: 'Günlük değişim limiti:',
  monthlyExchangeQuota: 'Aylık değişim limiti:',
  confirmTitle: 'Coin için',
  confirmTips: 'Değiştirmek istediğiniz miktarı kontrol edin (Bean Bakiye {{amount}})',
};

const coffee = {
  coffee: 'Kahve',
  tips: '*Değişim için minimum kahve: {{ num }}',
  dailyExchangeTimes: 'Günlük değişim sayısı:',
  dailyExchangeQuota: 'Günlük değişim limiti:',
  monthlyExchangeQuota: 'Aylık değişim limiti:',
  confirmTitle: 'Coin için',
  confirmTips: 'Değiştirmek istediğiniz miktarı kontrol edin (Kahve Bakiye {{amount}})',
};

const pearl = {
  pearl: 'Pearl',
  confirmTitle: 'Coin için',
  confirmTips: 'Değiştirmek istediğiniz miktarı kontrol edin (Pearl Bakiye {{amount}})',
  amountTips: 'Gönderim için minimum pearl:{{ num }}',
};

export default {
  title: 'Değişim',
  enter: 'Alıcının hesabını girin',
  exchanging: 'Değiştiriliyor...',
  rateBeanToCoin: '{{bean}} Bean = {{coin}} Coin',
  rateCoffeeToCoin: '{{coffee}} ml = {{coin}} Coin',
  success: 'Değişim başarılı',
  successTips: 'Değiştirdiğiniz miktarı kontrol edin',
  failure: 'Uyarı',
  failureTips: 'Mevcut işlem anormal, lütfen işlem detaylarına giderek sonucu doğrulayın',
  minNum: 'Her seferinde ≥ {{num}} bean olmalı',
  bean,
  pearl,
  coffee,
};
